import { DotFactory } from '@dot-map-renderer/component';

export type GeoJSONRendererOption = {
    backgroundColor: string;
    pixelColor: string;
    pixelSize: number;
    gapSize: number;
    dotFactory: DotFactory,
};
